var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJeffreygreet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.44 430.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-4 {\n        stroke: #474748;\n      }\n\n      .cls-2 {\n        stroke: #d7d7d7;\n      }\n\n      .cls-2, .cls-8 {\n        fill: #d7d7d7;\n      }\n\n      .cls-3 {\n        fill: #6d6d6d;\n        stroke: #6d6d6d;\n      }\n\n      .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: #474748;\n      }\n\n      .cls-5 {\n        fill: #b6b6b6;\n        stroke: #b6b6b6;\n      }\n\n      .cls-6 {\n        fill: #e9e9e9;\n        stroke: #e9e9e9;\n      }\n\n      .cls-7 {\n        fill: #a7a7a7;\n        stroke: #a7a7a7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Colour_mirror",
    "data-name": "Colour mirror"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M316.23,313.1l-9.2,4.3-2.4-3,2.3-24.2-30.8-18.2-30.9,6.2-30.9-6.2-30.8,18.2,2.3,24.2-2.4,3-9.2-4.3-5.2,5.1v9.2l14.5,23,5.2,3.6,6.8-1.5s11.1,26.6,20.2,34.5c9.2,7.9,15.7,12.6,15.7,12.6l13.8,1.4h0l13.8-1.4s6.5-4.7,15.7-12.6c9.2-7.9,20.2-34.5,20.2-34.5l6.9,1.5,5.2-3.6,14.5-23v-9.2l-5.2-5.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175.43,325.5s-.8,1.1,2,5.7c2,3.3,3.9,8.5,6.2,10,0,0-.7-11.7-2.1-13.5s-6.2-2.2-6.2-2.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.33,317l-5.3,2.5s.9,4.5,4.1,5.7,10.3,1.3,10.3,1.3c0,0,11.5-.2,12.6-.9,2.6-1.7,2.6-7.9,2.6-7.9l-13.8-2.4-10.5,1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "213.83 315.3 212.03 320.8 215.23 325.5 224.23 324.7 225.53 319.3 221.93 316 213.83 315.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.23,351.1s-5-1.8-6.6-1.3c-3.2,1-4,2.7-4,2.7,0,0,7.9,2.9,10.6,2.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M315.13,325.5s.8,1.1-2,5.7c-2,3.3-3.9,8.5-6.2,10,0,0,.7-11.7,2.1-13.5s6.2-2.2,6.2-2.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.23,317l5.3,2.5s-.9,4.5-4.1,5.7-10.3,1.3-10.3,1.3c0,0-11.4-.2-12.6-.9-2.6-1.7-2.6-7.9-2.6-7.9l13.8-2.4,10.5,1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "276.73 315.3 278.53 320.8 275.33 325.5 266.33 324.7 265.03 319.3 268.63 316 276.73 315.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.23,351.1s5-1.8,6.6-1.3c3.2,1,4,2.7,4,2.7,0,0-7.9,2.9-10.6,2.9"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Colour_Normal",
    "data-name": "Colour Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M259.73,308.5s-7.1,10.8-7.8,13,1.3,28.3,1.3,28.3l1.1,3.4s9.2-2.6,9.2-6.2-5.8-25.4-5.8-25.4c0,0,6.2-9.6,14.4-7.1,3.7,1.1-3.1-8.7-3.1-8.7l-9.2,2.8h0l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M288.03,290.1s-1.5,12.5-3.4,15.5-2.9,10.1-2.9,10.1l11.3,3.2s-3.5,10.5-5.1,12-4.7,2.8-5.6,6.6c-.9,3.8-2.9,25.3-5.3,31.7s-13.8,27.6-13.8,27.6c0,0,20.4-22.5,23.3-28.1s15.1-33.8,15.2-40.1,2.5-22.2,2.5-22.2l-16.1-16.4-.1.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "178.93 268.2 168.53 288.6 173.53 304.5 173.53 312.2 184.53 315.3 188.83 300.6 194.03 296.5 188.73 294.3 196.43 287.4 208.13 283.4 217.43 285.1 213.43 276.3 224.33 277.1 229.23 280.9 239.63 280.5 244.43 277.7 250.93 278.2 261.03 280.2 270.23 283.4 272.63 286.3 281.23 288.6 292.33 291.8 294.23 298.9 299.03 301.3 301.63 307.7 304.13 319 312.93 313.1 318.93 311.8 325.93 294.4 322.43 287.8 321.93 275.7 320.93 256.4 314.53 253.7 304.13 238.3 298.23 224.8 294.63 220.6 292.33 216.4 275.43 226.7 269.73 226.2 272.63 219.5 259.63 223.4 241.63 224 224.53 230.6 216.43 239.9 215.53 227.7 215.13 223.2 201.63 236 193.53 240.6 183.13 251.7 181.73 265.8 178.93 268.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.43,238.7s3.1-7.8,13.3-10.4c6.2-1.6,15.5-1.8,21,1.7,0,0-10.8,2.2-9.4,6.8s9.2,6,18.8,7.2,8.2,3,8.2,3c0,0-16.8,7.6-22.5,9.5s-27.2.6-25.8-5.6c1.8-8,8.3-9.4,5.4-12.1s-9.1,0-9.1,0h0l.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.13,253.2s-3.9,9-1.8,13.4,8.7,8.8,15.7,7,3.2-8.8,2.8-11.3-3.7-11.4-2.5-17.8c0,0-3.8,3.7-4.9,9.2-.9,4.3.2,9.5-3.5,8.1s-5.6-8.6-5.6-8.6h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M176.53,280.9c4.2-1.9,7.3,3.4,8.5,3.7s6.6,1.6,6.2,2.7-5.4,1.6-7.3,3.3-1.3,3-2.3,4.1-8.1.9-9.3-2.8.8-9.4,4.3-11h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.13,262.3c-3-1,12-4.9,16.5-8.6s10.7-9.1,12.3-9.9c1.2-.7-1,9.9-7.4,13.5-7.8,4.4-16.6,6.6-21.4,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.13,269.2c-.9.2-1.4-.9-.8-1.5,4.3-4.1,8.9-8.3,15.4-12.4,1.4-.9,6.1-4.5,7.7-3.9s-.3,4.8,1.1,11.4-4.2,13-11.8,15.4c0,0,2.6-3.1.2-7-1.5-2.5-8.5-2.6-11.8-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.03,283.8c1.9-1.9,6.9-11.5,8.3-10s.2,11.3-4.3,12.6-15.1,3.9-15.1,2.8,9.5-3.8,11.1-5.4h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror",
    "data-name": "Lines Mirror"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.23,402.2s4,0,11.1-1.6c12.3-2.9,27.2-22.8,34.3-35.4,7.5-13.2,14.9-46.2,14.9-46.2,0,0,6.2-7.6,12-5.6s4.7,12.6,3.7,14.7-11.2,22.8-17.3,26.1c-3.7,2.1-7.4-1.7-7.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.23,324.5s.5-2.1-1.4-2.1-6.6,4.9-7.5,8.8.4,8-1,11.7c-1.1,2.8-2.6,3.1-2.6,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.63,325.5s-4.8,2.2-11.1,1.8c-2.1-.1-6.4-1.2-9.8-1.2s-6.1.8-6.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.13,307.8s-9.1-2.1-16.1-2.9c-4.2-.5-13.6-.5-14.4-.2s-4.2,3.6-3.3,3.8c1.1.2,13.1-1.9,18.8-1.9,6.7,0,15.1,1.2,15.1,1.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.93,319s-13.7-4.6-18.8-4.4-13.4,4-13.4,4c0,0,2.7-5.3,4.6-6.2s8.5-1.5,8.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.83,314.8s2.5,3.3,2.8,5.6c.4,3.2-3.4,6.5-3.4,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.33,317.4s-1.2,2.8-.7,4.8,2.1,3.3,2.1,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.73,352.6s-1.1-.2-2,0-2.1,1.3-2.1,1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.23,402.2s-4,0-11.1-1.6c-12.3-2.9-27.2-22.8-34.3-35.4-7.5-13.2-14.9-46.2-14.9-46.2,0,0-6.2-7.6-12-5.6s-4.7,12.6-3.7,14.7,11.3,22.8,17.3,26.1c3.7,2.1,7.4-1.7,7.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.33,324.5s-.5-2.1,1.4-2.1,6.6,4.9,7.5,8.8c.8,3.9-.4,8,1,11.7,1.1,2.8,2.6,3.1,2.6,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.93,325.5s4.8,2.2,11,1.8c2.1-.1,6.4-1.2,9.8-1.2s6.1.8,6.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.43,307.8s9.1-2.1,16.1-2.9c4.2-.5,13.6-.5,14.4-.2s4.2,3.6,3.3,3.8c-1.1.2-13-1.9-18.8-1.9-6.7,0-15,1.2-15,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.63,319s13.7-4.6,18.8-4.4,13.5,4,13.5,4c0,0-2.7-5.3-4.6-6.2s-8.5-1.5-8.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.73,314.8s-2.5,3.3-2.8,5.6c-.4,3.2,3.4,6.5,3.4,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.23,317.4s1.2,2.8.7,4.8-2.1,3.3-2.1,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.83,352.6s1.1-.2,2,0,2.1,1.3,2.1,1.3"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Normal",
    "data-name": "Lines Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.03,319s2.2-13.3,4-16.2,7.4-6.7,7.4-6.7l-5.7-1.6s1.9-3.8,4.9-5.4c3-1.6,12.5-3.8,12.5-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.03,313.4c-2.2-3.5-1-8.9-1-8.9-3.3-3.9-4.9-9.9-4.5-15.1,1-10.8,12.3-24.5,12.3-24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.23,236.7c-12.1,4.2-18.4,19.2-18.4,28.1s6.5,12.3,13.1,16c4,2.3,26.7,4.4,26.7,4.4l-5.4-7.2,9.1,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.53,256.5s-2.7-7.2,1.1-14.6c3.8-7.4,16.9-15.7,19.2-22.4,0,0,3.9,7.5,3.2,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.43,281.8s-11.6-6-13.6-14.7-2.3-19.6,5.2-30.4,15.2-13.1,28.2-14.6c7.8-.9,17.4,2.4,28.8-7.2,0,0,0,7.4-5.1,11.4,0,0,9.7-1.4,14.2-4.7s10.2-7.8,10.2-7.8c0,0,5.4,16.1-7.8,28.9-13.1,12.8-32,15.2-39.3,21.3s-6.2,15.2-6.2,15.2c0,0-3.1,5.3-14.5,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.33,219.5s6.7,7.5,6.2,15.8c-.5,8.3-7.2,14.7-7.2,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.63,279.6s5.3,2.2,9.8.7,18.8-10.8,18.8-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.63,278.2s-12.6,6-18.1,5.7-13.1-3.8-13.1-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.83,236s3.6,5.6,7.2,9c3.6,3.4,9.7,8.1,1.6,26-7.1,15.9-21.4,14.5-32.8,17.2-7.4,1.8-9.9-2.8-9.9-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.23,253.7s4.6.9,5.7,4.5,1.4,25.5-6.3,33.2-15.7,11-22.2,8.4c-1.9-.8-.4-4.6-.5-5.9s-10.2-1-12.1-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.43,275.7c1.3,2.4,0,9,.9,12.9s3.7,4.4,2.4,11-8.1,13.6-8.1,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.73,300.6s-1.9,1.2-.1,5.8,3.8,4.5,4.2,11.2,0,10.5,0,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.83,241.1s-7.8,9.1-8.7,15.8-1.6,15.5,5.2,22.7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Hand_Color",
    "data-name": "Hand Color"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "338.53 366.9 338.03 339.1 339.73 323.7 344.73 304.8 350.43 310.1 350.93 323.3 353.23 328.4 368.13 308.4 383.73 296.1 394.13 291.3 392.73 298.7 383.33 307.4 375.23 319.1 374.53 326.1 385.43 316.9 396.43 309.7 409.03 300.8 413.53 306.5 414.43 315.1 414.03 321.2 397.33 345.5 388.83 369.5 381.23 378.5 338.53 366.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.73,344.8s.1,11.2,5,16.1c2.1,2.1,17.9-7.6,18.2-8.5,1.6-4-6.9-6-10.7-6,0,0-2.1-5-7.1-6.7s-8.2.6-8.2.6l2.7,4.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M413.53,306.5s-8.5,12.7-12.7,14.7-14.4,14.4-14.4,14.4c0,0,2.5,3.3,4.1,6.8,1.6,3.5-7.3,21.6-9.6,24.7s-10.2,10.5-10.2,10.5l10.8,4.3s8.2-13.8,11.9-21.7,9.9-25.7,9.9-25.7l11.9-16-.6-6.1-1.1-5.8h0v-.1Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Hand_lines",
    "data-name": "Hand lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.43,346.9c3-13.3-5.4-22.1-6.5-23.6s.8-10.5.8-12.4c0-5.1-5.5-6.5-6.9-6.2s-4.1,6.5-5.6,10.6-3.7,21.3-4.1,27.8,2.6,20,2.6,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.43,328.8s4.3-12.3,7.2-15.9,6.3-7.3,9-8.7,6.7-3.9,7.3-9.6-1.7-5.7-1.7-5.7c0,0-11,5-13.2,6.7s-14.4,11.8-16.2,13.9-11.8,14.7-11.8,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.13,322s10.5-7.9,11.6-8.5,12.1-6.9,13.3-8.4,7.9-6.4,7.9-6.4c1.6,1.1,3.4,4.3,2.8,6.9-1.8,7.7-12.3,14.3-13.9,14.9-3,1.3-13,14.6-13,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.83,339.1s8.8-11.8,10.8-13.2,10.6-10.6,11.1-13.5,2.3-9.1-1.4-8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.33,313.9s2.1,3.6,1.1,6.4-6.9,11.3-9.4,13.3-8.1,13.3-8.1,13.3c-2.1,6-5,14.1-5,14.1,0,0-3.7,11.9-9.4,16.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeffreygreet1);
export default __webpack_public_path__ + "static/media/jeffreygreet1.46d3f59a383919f66f43be76a471e27e.svg";
export { ForwardRef as ReactComponent };